export default __webpack_public_path__ + "10d377be8b1b7433c974c03ce66ed4af.png";